import type { Dictionary } from './core.js';

export const uk: Dictionary = {
  'app.title': 'Дурень',
  'app.cardsCredit':
    'Карти: SVG Playing Cards від Daniel S. Fowler (tekeye.uk), CC0 / суспільне надбання.',

  'mode.local': 'На цьому пристрої',
  'mode.online': 'Онлайн-кімната',
  'mode.localLede': 'Гра проти ботів або одне проти одного на одному пристрої.',
  'mode.onlineLede':
    'Гра з живими гравцями. Створи кімнату й надішли код — не треба ні акаунта, ні встановлення.',

  'conn.online': "під'єднано",
  'conn.connecting': "під'єднуюсь…",
  'conn.offline': "від'єднано",

  'field.players': 'Гравців',
  'field.deck': 'Колода',
  'field.seed': 'Сід',
  'field.seedHint': 'Той самий сід роздасть ті самі карти — гра повністю відтворювана.',
  'field.name': "Твоє ім'я",
  'field.roomCode': 'Код кімнати',
  'field.seat': 'Місце {n}',
  'player.seat': 'Гравець {n}',
  'field.language': 'Мова',
  'deck.36': '36 карт',
  'deck.52': '52 карти',
  'seat.human': 'Людина',
  'seat.soon': ' (скоро)',

  'action.newGame': 'Нова гра',
  'action.undo': 'Назад',
  'action.createRoom': 'Створити кімнату',
  'action.join': "Приєднатися",
  'action.start': 'Почати гру',
  'action.rematch': 'Реванш',
  'action.leave': 'Вийти з кімнати',
  'action.copyLink': 'Скопіювати посилання',
  'action.copied': 'Скопійовано',
  'action.sitHere': 'Сісти сюди',
  'action.removeBot': 'Прибрати',
  'action.send': 'Надіслати',
  'action.take': 'Беру',
  'action.pass': 'Біто / досить підкидати',
  'action.transfer': 'Перевести {card}',
  'action.transferReveal': 'Перевести {card} (показати)',
  'action.switchTo': 'Перейти на {name}',

  'board.trump': 'Козир',
  'board.trumpIs': 'Козир: {suit}',
  'board.bout': 'Коло {n}',
  'board.deck': 'Колода {n}',
  'board.discard': 'Відбій {n}',
  'board.deckEmpty': 'Колода порожня',
  'board.table': 'Стіл',
  'board.trumpCard': 'Козирна карта на дні колоди',
  'board.attacks': '{name} атакує.',
  'board.gameOver': 'Гру завершено.',
  'board.unbeatenHint': 'Не побито — клацни, щоб обрати ціль захисту',
  'board.noCards': 'без карт',
  'board.switchHint': 'Перейти на цього гравця',
  'board.notYours': 'За це місце ти зараз не граєш',
  'board.manyActors': 'Ходити можуть кілька гравців одночасно.',
  'board.waiting': 'Чекаємо на інших…',
  'board.cards': {
    one: '{count} карта',
    few: '{count} карти',
    many: '{count} карт',
    other: '{count} карти',
  },

  'settings.title': 'Налаштування гри',
  'settings.botSpeed': 'Пауза ботів',
  'settings.botSpeed.hint': 'Скільки бот чекає перед тим, як покласти карту. Нуль — миттєво.',
  'settings.seconds': '{n} с',
  'settings.holdForThrowIn': 'Зачекати на мене, коли можу підкинути',
  'settings.holdForThrowIn.hint': 'Боти зупиняться, доки ти не зіграєш або не натиснеш «Біто». Без цього хтось може підкинути раніше, ніж ти це помітиш.',
  'settings.showLog': 'Показувати перебіг гри',
  'settings.showLog.hint': 'Бічна колонка з тим, хто що поклав.',
  'board.yourThrowIn': 'Можеш підкинути — зіграй карту або натисни «Біто».',
  'settings.showStatus': 'Показувати дані гри',
  'settings.showStatus.hint': 'Козир, коло, залишок колоди та відбій — над твоїми картами.',
  'setup.title': 'Налаштування та нова гра',
  'card.back': 'Сорочка',
  'card.deckOf': 'У колоді {count} карт',

  'role.bot': 'бот',
  'role.away': "від'єднаний",
  'role.substituted': 'за нього грає бот',
  'role.attacks': 'атакує',
  'role.defends': 'захищається',
  'role.takes': 'бере',
  'role.out': 'вийшов з гри',
  'role.passed': 'спасував',

  'suit.clubs': 'Трефи',
  'suit.diamonds': 'Бубни',
  'suit.hearts': 'Черви',
  'suit.spades': 'Піки',

  'banner.stalemate': 'Патова позиція — карти лише ходили по колу, дурня немає.',
  'banner.draw': 'Нічия — усі позбулися карт одночасно.',
  'rules.teams': 'Команди 2в2',
  'rules.teams.hint': 'Четверо гравців, пари навпроти. Партнери не атакують і не переводять одне на одного.',
  'team.name': 'Команда {n}',
  'banner.teamLost': 'Програє {team}.',
  'banner.durak': 'Дурень — {name}.',

  'log.title': 'Перебіг',
  'log.dealt': 'Роздано. Козирна карта: {card}.',
  'log.attack': '{name} атакує {card}.',
  'log.throwIn': '{name} підкидає {card}.',
  'log.defend': '{name} б’є картою {card}.',
  'log.transfer': '{name} переводить {card} на {target}.',
  'log.transferReveal': '{name} показує {card} і переводить атаку на {target}.',
  'log.takeDeclared': '{name} бере.',
  'log.take': '{name} забирає {cards}.',
  'log.pass': '{name} пасує.',
  'log.bito': 'Біто: {cards}.',
  'log.draw': '{name} добрав {count} карт.',
  'log.trumpTaken': '{name} бере козирну карту {card} — колода порожня.',
  'log.out': '{name} позбувся карт.',
  'log.stalemate': 'Патова позиція — гра вже нікуди не рухалась.',
  'log.drawGame': 'Нічия — дурня немає.',
  'log.durak': 'Дурень: {name}.',

  'bots.hint.none': 'Усі місця займають люди на одному пристрої.',
  'bots.1.name': 'Початківець',
  'bots.1.blurb': 'Грає найдешевшу можливу карту й береже козирі. Нічого не запам’ятовує.',
  'bots.2.name': 'Досвідчений',
  'bots.2.blurb': 'Стежить за фазою гри, ощадливий з козирями, зважує, чи варто брати.',
  'bots.3.name': 'Рахівник',
  'bots.3.blurb': 'Рахує скинуті карти й оцінює, чим суперник може побити.',
  'bots.4.name': 'Майстер',
  'bots.4.blurb': 'Моделює руку суперника й свідомо блефує.',

  'lobby.room': 'Кімната',
  'lobby.shareHint':
    'Надішли цей код або посилання будь-кому, хто має приєднатися. Реєстрація не потрібна.',
  'lobby.host': 'господар',
  'lobby.you': 'ти',
  'lobby.rulesByHost': 'Правила налаштовує господар кімнати.',
  'lobby.startByHost': 'Гру запускає господар.',
  'lobby.chatPlaceholder': 'Напиши щось…',
  'lobby.chatLabel': 'Повідомлення в чат',
  'lobby.addBot': '+ {name}',

  'rules.title': 'Правила',
  'rules.custom': 'власні налаштування',
  'rules.scope': 'Хто може підкидати',
  'rules.scope.all': 'Будь-хто',
  'rules.scope.neighbours': 'Лише сусіди того, хто захищається',
  'rules.cap': 'Ліміт атаки',
  'rules.cap.defenderHand': 'За рукою захисника',
  'rules.cap.unlimited': 'Без ліміту',
  'rules.cap.fixed4': 'Щонайбільше 4 карти',
  'rules.cap.fixed6': 'Щонайбільше 6 карт',
  'rules.afterTake': 'Підкидання після «беру»',
  'rules.afterTake.sameAsAttack': 'Той самий ліміт, що й атака',
  'rules.afterTake.defenderHandAtBoutStart': 'За рукою на початку кола',
  'rules.afterTake.unlimited': 'Аж до межі столу',
  'rules.firstAttacker': 'Хто починає',
  'rules.firstAttacker.lowestTrump': 'Найменший козир',
  'rules.firstAttacker.random': 'Випадково',
  'rules.transfer': 'Переведення (перевідний)',
  'rules.transfer.hint': 'Захисник може передати атаку далі картою того самого номіналу.',
  'rules.chains': 'Ланцюжок переведень',
  'rules.chains.hint': 'Новий захисник теж може перевести далі.',
  'rules.reveal': 'Переведення показом козиря',
  'rules.reveal.hint': 'Козир того самого номіналу досить показати, він лишається в руці.',
  'rules.mustBeat': 'Захисник мусить бити, якщо може',
  'rules.mustBeat.hint':
    'Брати можна лише тоді, коли справді немає чим побити. Змінює гру більше, ніж здається.',
  'rules.throwInAfterTake': 'Підкидати і після «беру»',
  'rules.firstBoutCap': 'Перше коло обмежене',
  'rules.firstBoutCap.hint': 'Перша атака в грі має щонайбільше на карту менше, ніж розмір руки.',
  'rules.trumpVisible': 'Козирна карта видима',
  'rules.trumpVisible.hint': 'Нижня карта колоди лежить лицем догори.',

  'preset.classic': 'Класичний дурень',
  'preset.classic.blurb': '36 карт, підкидати може будь-хто, захисник може взяти будь-коли.',
  'preset.perevodnoy': 'З переведенням',
  'preset.perevodnoy.blurb':
    'Захисник може перевести атаку на наступного гравця картою того самого номіналу.',
  'preset.strict': 'Суворий',
  'preset.strict.blurb': 'Брати можна лише коли нічим бити, перше коло обмежене.',
  'preset.big': 'Великий стіл',
  'preset.teams': 'Команди 2в2',
  'preset.teams.blurb': 'Четверо гравців, пари сидять навпроти. Партнер ніколи на тебе не атакує.',
  'preset.big.blurb': '52 карти для 5–6 гравців, атакують лише сусіди захисника.',

  'problem.deck_too_small':
    '{deckSize} карт замало для {players} гравців — треба щонайменше {needed}, щоб лишилася козирна карта.',
  'problem.deck_barely_sufficient':
    'Після роздачі в колоді лишиться дуже мало карт, ендшпіль настане майже одразу.',
  'problem.players_out_of_range': 'Кількість гравців має бути від {min} до {max}.',
  'problem.hand_size_out_of_range': 'Непідтримуваний розмір руки.',
  'problem.max_table_slots_out_of_range': 'Непідтримуваний ліміт карт на столі.',
  'problem.first_bout_cap_meaningless':
    'Обмеження першого кола не має сенсу за такої малої руки.',
  'problem.attack_cap_out_of_range': 'Непідтримуваний ліміт атаки.',
  'problem.scope_has_no_effect':
    'За такої кількості гравців сусідом захисника є кожен — вибір нічого не змінює.',
  'problem.transfer_options_without_transfer':
    'Підопції переведення нічого не роблять, доки саме переведення вимкнене.',
  'problem.transfer_two_players':
    'Удвох переведена атака повертається до атакувальника — гра стає різкішою.',
  'problem.must_beat_all_changes_the_game':
    'Правило «мусить бити» забирає в захисника вибір і суттєво допомагає ботам, які рахують.',
  'problem.must_beat_all_with_unlimited_pile':
    'З необмеженим підкиданням після «беру» атакувальники можуть перемолоти всю руку захисника.',
  'problem.teams_need_four': 'Команди 2в2 грають рівно вчотирьох, зараз вас {players}.',
  'problem.scope_ignored_in_teams': 'У командах сусідами захисника є саме обидва суперники — вибір нічого не змінює.',
  'problem.not_enough_players': 'Для гри потрібні щонайменше двоє — додай гравця або бота.',

  'error.room_not_found': 'Кімнати з таким кодом немає. Перевір код.',
  'error.room_full': 'Кімната заповнена.',
  'error.room_in_progress': 'У кімнаті вже триває гра.',
  'error.not_host': 'Це може змінити лише господар кімнати.',
  'error.not_enough_players': 'Для гри потрібні щонайменше двоє гравців.',
  'error.server_full': 'Сервер зараз заповнений, спробуй за хвилину.',
  'error.seat_taken': 'Це місце вже зайняте.',
  'error.rate_limited': 'Забагато дій одразу, трохи повільніше.',
  'error.illegal_move': 'Цей хід не за правилами.',
  'error.protocol_mismatch': 'Сторінка застаріла — онови її (Ctrl+R).',
  'error.unknown': 'Помилка: {code}',

  // --- table design (skins, chairs, waiting room) ---
  'role.idle': 'чекає',
  'turn.you.attack': 'Ти · атакуєш',
  'turn.you.defend': 'Ти · захищаєшся',
  'turn.you.act': 'Ти · твій хід',
  'settings.appearance': 'Вигляд',
  'settings.skin': 'Графічний стиль',
  'settings.theme': 'Денний / нічний режим',
  'skin.organic': 'Organic',
  'skin.modern': 'Modern',
  'skin.classic': 'Класика',
  'theme.light': 'Денний',
  'theme.dark': 'Нічний',
  'entry.kicker': 'Ласкаво просимо за стіл',
  'entry.title': 'Зіграй у дурня.',
  'entry.botsKicker': 'Суперники',
  'entry.botsTitle': 'Боти, яких можна посадити за стіл',
  'lobby.waitingTitle': 'Чекаємо на гравців',
  'lobby.seatsFilled': 'Зайнято {n} із {max} місць',
  'lobby.chat': 'Чат',
  'lobby.facts': 'Налаштування столу',
  'lobby.invite': 'Запросити',
  'lobby.seated': 'За столом',
  'lobby.free': 'Вільне місце',
  'lobby.freeHint': 'чекає на гравця або бота',
  'lobby.player': 'гравець',
  'lobby.fact.seats': 'Заповненість',
  'lobby.fact.code': 'Код кімнати',
  'yes': 'так',
  'no': 'ні',

  // --- decks, sorting, hints ---
  'settings.cardTheme': 'Колода карт',
  'cards.classic': 'Класична',
  'cards.minimal': 'Мінімал',
  'settings.sortBy': 'Сортувати карти',
  'sort.suit': 'За мастю',
  'sort.power': 'За силою',
  'settings.hints': 'Підказка ходу',
  'settings.hints.hint': 'Затемнює карти, якими зараз не можна ходити. Вимкнено — рука виглядає однаково і стежиш сам.',
  'role.canThrowIn': 'може підкинути',
};
